// extracted by mini-css-extract-plugin
export default {"footer":"_6tVr","quantity":"cfdp1","prices":"KHVDR","expiredPrice":"uxlnR","actualPrice":"JyqFE"};